<template>
  <div>
    <h2>Отчеты</h2>

    <div class="mt-4">
      <b-form>
        <b-form-row>
          <b-col cols="3">
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <multiselect
                v-model="filters.partner"
                :options="optionsPartners"
                :searchable="true"
                :internal-search="false"
                :hide-selected="true"
                track-by="name"
                label="name"
                placeholder="Введите название партнера"
                :multiple="false"
                selectLabel="Enter чтобы выбрать"
                @search-change="asyncPartnersFind"
              >
                <span slot="noResult">Не найдено</span>
              </multiselect>
            </b-input-group>
          </b-col>
          <b-col cols="2">
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-form-datepicker
                v-model="filters.dateFrom"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                locale="ru"
                placeholder="Начиная с даты"
                label-reset-button="Сбросить"
                reset-button
              ></b-form-datepicker>
            </b-input-group>
          </b-col>
          <b-col cols="2">
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-form-datepicker
                v-model="filters.dateTo"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                locale="ru"
                placeholder="До даты"
                label-reset-button="Сбросить"
                reset-button
              ></b-form-datepicker>
            </b-input-group>
          </b-col>
          <b-col cols="5">
            <b-button @click="submitFilter" class="mr-2">Сформировать отчет</b-button>
            <b-button @click="dataExport" class="mr-2">Выгрузка в Excel</b-button>
            <b-button v-if="filters.dateFrom || filters.dateTo || filters.partner" @click="clearFilters">Очистить фильтр</b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </div>

    <div class="mt-4">
      <div v-show="isLoading">
        <b-skeleton-img no-aspect height="300px"></b-skeleton-img>
      </div>

      <highcharts v-show="!isLoading" :options="chartOptions"></highcharts>
    </div>

    <div class="mt-4">
      <b-table
        striped hover small show-empty ref="tableSales"
        :items="sales"
        :fields="fieldsSales"
        :busy.sync="isBusySales"
        empty-text="Нет данных"
        empty-filtered-text="Не найдено"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner small class="align-middle mr-2"></b-spinner>
            <strong>Загрузка ...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <div class="mt-4">
      <b-table striped hover small show-empty ref="table"
               :items="tableDataProvider"
               :fields="fields"
               :busy.sync="isBusy"
               empty-text="Нет данных"
               empty-filtered-text="Не найдено"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :per-page="perPage"
               :current-page="currentPage"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner small class="align-middle mr-2"></b-spinner>
            <strong>Загрузка ...</strong>
          </div>
        </template>
        <template v-slot:cell(name)="data">
          <div>{{ data.item.name }}</div>
          <div class="text-muted"><small>{{ data.item.email }}</small></div>
        </template>
        <template v-slot:cell(twoMonthsAgo)="data">
          {{ data.item.twoMonthsAgo }} руб.
        </template>
        <template v-slot:cell(oneMonthAgo)="data">
          {{ data.item.oneMonthAgo }} руб.
        </template>
        <template v-slot:cell(currentMonth)="data">
          {{ data.item.currentMonth }} руб.
        </template>
      </b-table>
      <b-pagination align="center"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>


<script>
import commonMixin from '../mixins/common';
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import Multiselect from 'vue-multiselect';

exportingInit(Highcharts)

export default {
  name: 'ReportPartnerSales',
  mixins: [commonMixin],
  components: {
    highcharts: Chart,
    multiselect: Multiselect,
  },
  data() {
    return {
      test: '',
      users: [
        {id: 1, name: 'name1'},
        {id: 2, name: 'name2'},
        {id: 3, name: 'name3'},
      ],
      optionsPartners: [],
      chartOptions: {
        series: []
      },
      filters: {
        dateFrom: null,
        dateTo: null,
        partner: null,
      },
      sortBy: 'id',
      sortDesc: true,
      isBusy: false,
      isBusySales: false,
      isBusyButton: false,
      isLoading: false,
      totalRows: 1,
      errorResult: null,
      messageResult: '',
      perPage: 20,
      currentPage: 1,
      error: false,
      message: '',
      searchQuery: {
        query: '',
      },
      fields: [
        {key: 'id', label: '#', sortable: true},
        {key: 'name', label: 'Партнер', sortable: true},
        {key: 'twoMonthsAgo', label: 'Сумма продаж 2 месяца назад', sortable: true},
        {key: 'oneMonthAgo', label: 'Сумма продаж 1 месяц назад', sortable: true},
        {key: 'currentMonth', label: 'Сумма продаж в этом месяце', sortable: true},
      ],
      items: [],
      sales: [],
      fieldsSales: [
        {key: 'date', label: 'Дата', sortable: true},
        {key: 'partner', label: 'Партнер', sortable: true},
        {key: 'user_name', label: 'Клиент', sortable: true},
        {key: 'user_email', label: 'Email', sortable: true},
        {key: 'price', label: 'Сумма', sortable: true},
      ],
    }
  },
  created() {
    this.asyncPartnersFind('');

    let today = new Date();
    let month = String(today.getMonth() + 1).padStart(2, '0');
    this.filters.dateFrom = today.getFullYear() + '-' + month + '-01';
  },
  mounted() {
    this.fetchChart();
  },
  methods: {
    submitFilter() {
      this.fetchChart()
    },
    tableDataProvider(ctx) {
      return this.axios.get(process.env.VUE_APP_HS_URL + '/api/partner/report/partner-sales',
        {
          params: {
            page: ctx.currentPage,
            sortBy: ctx.sortBy,
            sortDesc: ctx.sortDesc,
            limit: 20,
          },
        })
        .then(response => {
          this.items = response.data.items;
          this.totalRows = response.data.totalRows;
          return this.items || []
        })
        .catch((error) => {
          console.log(error);
          this.items = [];
          this.totalRows = 0;
          return this.items || []
        });
    },
    asyncPartnersFind(query) {
      this.axios.get(process.env.VUE_APP_HS_URL + '/api/partner/report/partners?query=' + query).then(response => {
        this.optionsPartners = response.data.items;
      }).catch((error) => {
        console.log(error);
        this.optionsPartners = [];
      });
    },
    fetchChart() {
      this.isLoading = true
      this.isBusySales = true
      this.axios.get(process.env.VUE_APP_HS_URL + '/api/partner/report/sales', {
        params: {
          from: this.filters.dateFrom,
          to: this.filters.dateTo,
          partner: this.filters.partner ? this.filters.partner.id : null,
        },
      })
        .then(response => {
          this.chartOptions = response.data.chart
          this.sales = response.data.sales
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false
          this.isBusySales = false
        });
    },
    clearFilters() {
      this.filters = {
        dateFrom: null,
        dateTo: null,
        partner: null,
      }
      this.fetchChart()
    },
    async dataExport() {
      this.axios({
        url: process.env.VUE_APP_HS_URL + '/api/partner/report/sales/export',
        params: {
          from: this.filters.dateFrom,
          to: this.filters.dateTo,
          partner: this.filters.partner ? this.filters.partner.id : null,
        },
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reports.xlsx');
        document.body.appendChild(link);
        link.click();
      });
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.hidden-overflow {
  overflow: hidden;
  white-space: pre-wrap;
}
</style>
